export default __webpack_public_path__ + "static/logo-lockheed-martin-3d4eaa6c805fa876eff8217e99c9c4c9.png";